import PropTypes from 'prop-types';
import qs from 'qs';
import React, { useState } from 'react';
import { useHitsPerPage } from 'react-instantsearch';

import Dropdown from '@atoms/Dropdown';
import { getOptionByHitsPerPage, getPageSizeDefault, pageSizeOptions } from '@react/data/pageSizeOptions';

export const PageSizeDropdown = ({ onPageSizeChange }) => {
    const queryParams = qs.parse(window.location.search.slice(1));
    // const optionFromUrl = getOptionByHitsPerPage(Number(queryParams.perPage) || initialHitsPerPage);
    const optionFromUrl = getOptionByHitsPerPage(Number(queryParams.perPage));
    const optionDefault = getPageSizeDefault();
    const [pageSize, setPageSize] = useState(optionFromUrl || optionDefault);

    const { refine } = useHitsPerPage({
        items: pageSizeOptions.map(option => ({
            label: option.optionLabel,
            value: option.hitsPerPage,
            default: !!option.default,
        })),
    });

    return (
        <Dropdown
            options={pageSizeOptions}
            selectedOption={pageSize}
            dropdownClasses="dropdown"
            dropdownItemClasses="dropdown-item my-3 pl-3"
            dropdownMenuClasses="dropdown-menu dropdown-menu-right m-0 mt-2 px-2 align-self-start"
            dropdownMenuLinkClasses="nav-link text-primary sort-list p-0"
            onOptionSelect={selectedOption => {
                setPageSize(selectedOption);
                onPageSizeChange(selectedOption);
                refine(selectedOption.hitsPerPage);
            }}
        />
    );
};

PageSizeDropdown.propTypes = {
    onPageSizeChange: PropTypes.func.isRequired,
};
